var _style, _ellipse, _ellipse2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupremeDegenBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 330",
    style: {
      enableBackground: "new 0 0 330 330"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFD3AE;}\n\t.st1{fill:#333333;}\n\t.st2{opacity:0.44;fill:#333333;enable-background:new    ;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#F7774B;}\n\t.st5{fill:#541D00;}\n\t.st6{fill:#702600;}\n\t.st7{fill:#983300;}\n\t.st8{fill:#D5681E;}\n\t.st9{fill:#FF9933;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 33.5,
    cy: 187.4,
    rx: 27.6,
    ry: 27.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 299.5,
    cy: 187.4,
    rx: 27.6,
    ry: 27.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,221.2C15,221.2,0,206,0,187.4s15-33.8,33.5-33.8S67,168.7,67,187.4S52,221.2,33.5,221.2z M33.5,165.5 c-12,0-21.6,9.8-21.6,21.8c0,12.1,9.7,21.8,21.6,21.8s21.6-9.8,21.6-21.8C55.2,175.3,45.5,165.5,33.5,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.5,221.2c-18.5,0-33.5-15.2-33.5-33.8s15-33.8,33.5-33.8s33.5,15.2,33.5,33.8S315,221.2,296.5,221.2z  M296.5,165.5c-12,0-21.6,9.8-21.6,21.8c0,12.1,9.7,21.8,21.6,21.8c12,0,21.6-9.8,21.6-21.8C318.1,175.3,308.4,165.5,296.5,165.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.2,283.1c-21.5,9.5-47.5,15-75.4,15s-53.9-5.5-75.4-15c-0.3-0.1-0.6-0.3-0.9-0.4 c-35.4-15.9-58.7-42.6-58.7-72.9v-22.4V136c0-48.8,60.4-88.3,135-88.3l0,0c74.6,0,135,39.5,135,88.3v51.4v22.4 c0,30.3-23.3,57-58.9,72.9C241.7,282.8,241.4,283,241.2,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.2,283.1c18.1,6.7,38.9,11.5,61.3,13.7c-9,0.9-18.5,1.4-28,1.4c-33.1,0-63.9-5.5-89.4-15 c-0.4-0.1-0.7-0.3-1.1-0.4c-42-16-69.6-42.7-69.6-73v-22.4c0-138.7,99.3-137,99.3-134.1l-18.8,15.8c-27.9,23.3-27.7,53.1-1.8,76 c4.3,3.9,18.5,17.3,18.1,20.3c-0.9,11.3-16.6,21.3-38.5,21.9c-0.7,0-1.4,0-2.2,0v22.4c0,30.3,27.7,57,69.8,72.9 C152.4,282.8,152.8,283,153.2,283.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.5,76.5c29.2,9.4,50.8,25.3,58.3,44.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.8,126.9c-4.7,0-9.1-1.9-10.2-4.7c-6.9-17.1-26.2-31.8-53.2-40.5c-5.1-1.6-6.9-5.3-4-8.2 c2.8-2.9,9.3-3.9,14.4-2.3c32.1,10.4,55.3,27.9,63.4,48.3c1.2,3.2-2.3,6.4-7.9,7.2C269.4,126.8,268.5,126.9,267.8,126.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.7,304.1c-28.7,0-56.3-5.5-80-15.9c-0.2,0-0.3-0.1-0.3-0.2c0,0-0.2,0-0.2-0.1l-0.2-0.1 c-0.3-0.1-0.5-0.2-0.8-0.4c-39.2-17.7-62.7-46.7-62.7-77.8v-73.8c0-52,64.7-94.3,144.2-94.3c38.5,0,74.8,9.8,101.9,27.6 s42.3,41.5,42.3,66.6v73.8c0,31.1-23.5,60.1-62.7,77.8c-0.3,0.1-0.5,0.2-0.8,0.4l-0.2,0.1l-0.2,0.1c-0.2,0.1-0.2,0.1-0.3,0.1 C222,298.6,194.2,304.1,165.7,304.1z M95.7,278.2C95.8,278.2,95.8,278.2,95.7,278.2c20.8,9.1,45,13.9,69.9,13.9 c25,0,49.1-4.8,69.9-13.9c0,0,0,0,0.2,0s0.2-0.1,0.3-0.1l0.2-0.1c0.2,0,0.2-0.1,0.3-0.1s0.2-0.1,0.3-0.1 c34.3-15.4,54.8-40.8,54.8-67.9v-73.8c0-21.9-13.1-42.6-36.9-58.2s-55.4-24.1-89-24.1c-69.4,0-125.9,36.9-125.9,82.3v73.8 c0,27.1,20.4,52.6,54.8,67.9c0.2,0,0.2,0.1,0.3,0.1s0.2,0.1,0.3,0.1l0.2,0.1C95.5,278.1,95.7,278.2,95.7,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.8,156.8c-5.8,0-10.5-2.7-10.5-6v-10.7c0-3.3,4.7-6,10.5-6s10.5,2.7,10.5,6v10.7 C278.3,154.1,273.6,156.8,267.8,156.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M181.9,12.5l6.2,20c-6.7-4.8-14.5-7.2-22.3-7.2s-15.7,2.4-22.3,7.2l6.2-20l0,0C158.5,3.6,173,3.6,181.9,12.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M188.1,32.4L179.5,99h-27.6l-8.6-66.5c6.7-4.8,14.5-7.2,22.3-7.2C173.6,25.3,181.5,27.7,188.1,32.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "151.9,99 165.8,93.6 162.2,23.8 143.8,35.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.6,105H152c-3,0-5.5-2.2-5.8-5.2l-8.6-66.5c-0.3-2.2,0.7-4.4,2.5-5.7c7.6-5.4,16.5-8.3,25.8-8.3 c9.3,0,18.2,2.9,25.8,8.3c1.8,1.3,2.8,3.5,2.5,5.7l-8.6,66.5C185,102.7,182.6,105,179.6,105z M157.2,93h17.2l7.4-57.5 c-4.8-2.8-10.4-4.2-16-4.2s-11.2,1.4-16,4.2L157.2,93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.5,34.2l-5.7-18.4c-6.3-5.3-15.6-5.3-21.9,0l-5.7,18.4l-11.3-3.6l6.2-20c0.3-0.9,0.8-1.8,1.5-2.4 c11.3-11.1,29.5-11.1,40.6,0c0.7,0.7,1.2,1.5,1.5,2.5l6.2,20L182.5,34.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.8,
    y: 25.4,
    className: "st1",
    width: 11.9,
    height: 73.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.4,175.3c-2.5,0-4.9-1-6.6-2.9c-1.7-1.7-2.8-4.3-2.8-6.7s0.9-4.9,2.8-6.7c2.2-2.2,5.5-3.2,8.5-2.5 c0.6,0.2,1.3,0.3,1.7,0.5c0.6,0.2,1.1,0.5,1.6,1c0.5,0.3,0.9,0.8,1.4,1.3c0.5,0.5,0.8,1,1.3,1.4c0.5,0.5,0.6,1.1,0.9,1.6 c0.2,0.6,0.5,1.1,0.5,1.7c0.2,0.6,0.2,1.3,0.2,1.9c0,0.6,0,1.3-0.2,1.9c-0.2,0.6-0.3,1.3-0.5,1.7c-0.2,0.5-0.5,1.1-0.9,1.6 c-0.3,0.5-0.8,1-1.3,1.4C114.2,174.1,111.9,175.3,109.4,175.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.1,175.3c-0.6,0-1.3,0-1.9-0.2c-0.6-0.2-1.3-0.3-1.7-0.6c-0.6-0.2-1.1-0.5-1.6-1 c-0.5-0.3-0.9-0.8-1.4-1.1c-0.5-0.5-0.8-1-1.3-1.4c-0.3-0.5-0.6-1.1-0.8-1.6c-0.2-0.5-0.5-1.1-0.5-1.7c-0.2-0.6-0.2-1.3-0.2-1.9 c0-0.6,0-1.3,0.2-1.9c0.2-0.6,0.3-1.3,0.5-1.7c0.2-0.5,0.5-1.1,0.8-1.6c0.3-0.5,0.8-1,1.3-1.4s0.9-0.8,1.4-1.3 c0.5-0.3,1.1-0.6,1.6-1c0.6-0.2,1.1-0.5,1.7-0.5c3.1-0.6,6.3,0.3,8.5,2.5c0.5,0.5,0.8,1,1.3,1.4c0.5,0.5,0.6,1.1,0.8,1.6 s0.5,1.1,0.5,1.7c0.2,0.6,0.2,1.3,0.2,1.9c0,0.6,0,1.3-0.2,1.9c-0.2,0.6-0.3,1.3-0.5,1.7s-0.5,1.1-0.8,1.6 c-0.3,0.5-0.8,1-1.3,1.4C221,174.1,218.6,175.3,216.1,175.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.1,196.6c-5.2,0-9.4-4.3-9.4-9.5v-26.8c0-5.1-4.1-9.2-9.1-9.2H84.7c-5.2,0-9.4-4.3-9.4-9.5 s4.2-9.5,9.4-9.5h44.9c15.4,0,27.9,12.7,27.9,28.2v26.8C157.6,192.4,153.3,196.6,148.1,196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.2,151.3h-37.7c-5.2,0-9.4-4.3-9.4-9.5s4.2-9.5,9.4-9.5h37.7c5.2,0,9.4,4.3,9.4,9.5 S238.4,151.3,233.2,151.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.8,237.7h-46.5c-6.4,0-11.6-5.3-11.6-11.7s5.2-11.7,11.6-11.7h46.5c6.4,0,11.6,5.3,11.6,11.7 S193.2,237.7,186.8,237.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.8,126c-2.5,0-4.9-1-6.6-2.9c-1.7-1.7-2.8-4.3-2.8-6.7c0-2.4,0.9-4.9,2.8-6.7c1.7-1.7,4.2-2.9,6.6-2.9 s4.9,1,6.6,2.9s2.8,4.3,2.8,6.7c0,2.4-0.9,4.9-2.8,6.7C248.6,124.9,246.3,126,243.8,126z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.8,221.9v10.8c10.8,6.5,18.2,18.4,18.2,32v20.4c0,12.4,5.1,23.6,13.1,31.9l4.6-32.8l-4.6-48.4 C178.4,227.3,167.2,221.9,154.8,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M186.1,235.8V317c8,8.1,19.1,13,31.3,13l0,0l4.6-22.4l-4.6-22.4c-11.1,0-20.2-9.1-20.2-20.4 C197.2,253.7,193.1,243.4,186.1,235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M217.4,279.7V330h15c2.5,0,5-0.3,7.4-0.9l4.6-53.9L217.4,279.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M239.7,275.2v53.9c12.7-3.2,22.2-15,22.2-28.9v-20.4L239.7,275.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "239.7,279.7 244.2,268 217.4,268 217.4,279.7  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 239.7,
    y: 268,
    className: "st9",
    width: 22.2,
    height: 11.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "212.2,271.5 239.7,271.5 244.2,268 239.7,264.5 212.2,264.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.7,
    y: 264.5,
    className: "st6",
    width: 27.4,
    height: 6.9
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupremeDegenBadge);
export default __webpack_public_path__ + "static/media/supreme_degen_badge.7bd965afce5eebe7bbfbd1c7d5332531.svg";
export { ForwardRef as ReactComponent };